{
  "updated": "2026-11-03T12:08:05.501Z",
  "providers": {
    "runpod": {
      "name": "RunPod",
      "url": "https://www.runpod.io/pricing",
      "note": "Secure Cloud, on-demand, live price (it rises when stock is low)",
      "updated": "2026-11-03T12:08:05.501Z",
      "prices": {
        "b300": 8.99,
        "b200": 7.99,
        "h200": 5.29,
        "h100-nvl": 3.19,
        "h100": 3.99,
        "a100-80": 1.79,
        "l40s": 1.09,
        "l4": 0.59,
        "mi300x": 2.39,
        "rtx-pro-6000": 2.49,
        "rtx-6000-ada": 0.99,
        "rtx-5090": 1.19,
        "rtx-4090": 0.89,
        "rtx-3090": 0.5,
        "rtx-5080": 0.59,
        "rtx-3090-ti": 0.46,
        "l40": 0.82,
        "a40": 0.59,
        "rtx-a6000": 0.59,
        "rtx-a5000": 0.27,
        "rtx-a4500": 0.25,
        "rtx-a4000": 0.25,
        "rtx-4000-ada": 0.28,
        "rtx-2000-ada": 0.24,
        "rtx-pro-4000": 0.57,
        "rtx-pro-4500": 0.72,
        "h100-pcie": 2.89
      },
      "seen": {
        "b300": "2026-11-03T12:08:05.501Z",
        "b200": "2026-11-03T12:08:05.501Z",
        "h200": "2026-11-03T12:08:05.501Z",
        "h100-nvl": "2026-11-03T12:08:05.501Z",
        "h100": "2026-11-03T12:08:05.501Z",
        "a100-80": "2026-11-03T12:08:05.501Z",
        "l40s": "2026-11-03T12:08:05.501Z",
        "l4": "2026-11-03T12:08:05.501Z",
        "mi300x": "2026-11-03T12:08:05.501Z",
        "rtx-pro-6000": "2026-11-03T12:08:05.501Z",
        "rtx-6000-ada": "2026-11-03T12:08:05.501Z",
        "rtx-5090": "2026-11-03T12:08:05.501Z",
        "rtx-4090": "2026-11-03T12:08:05.501Z",
        "rtx-3090": "2026-11-03T12:08:05.501Z",
        "rtx-5080": "2026-11-03T12:08:05.501Z",
        "rtx-3090-ti": "2026-11-03T12:08:05.501Z",
        "l40": "2026-11-03T12:08:05.501Z",
        "a40": "2026-11-03T12:08:05.501Z",
        "rtx-a6000": "2026-11-03T12:08:05.501Z",
        "rtx-a5000": "2026-11-03T12:08:05.501Z",
        "rtx-a4500": "2026-11-03T12:08:05.501Z",
        "rtx-a4000": "2026-11-03T12:08:05.501Z",
        "rtx-4000-ada": "2026-11-03T12:08:05.501Z",
        "rtx-2000-ada": "2026-11-03T12:08:05.501Z",
        "rtx-pro-4000": "2026-11-03T12:08:05.501Z",
        "rtx-pro-4500": "2026-11-03T12:08:05.501Z",
        "h100-pcie": "2026-11-03T12:08:05.501Z"
      }
    },
    "verda": {
      "name": "Verda (DataCrunch)",
      "url": "https://verda.com/",
      "note": "On-demand",
      "updated": "2026-11-03T12:08:05.501Z",
      "prices": {
        "b300": 11.46,
        "b200": 8.958,
        "h200": 6.313,
        "h100": 4.84,
        "a100-80": 2.27,
        "a100-40": 1.625,
        "rtx-pro-6000": 2.67,
        "l40s": 1.92,
        "rtx-6000-ada": 1.513
      },
      "seen": {
        "b300": "2026-11-03T12:08:05.501Z",
        "b200": "2026-11-03T12:08:05.501Z",
        "h200": "2026-11-03T12:08:05.501Z",
        "h100": "2026-11-03T12:08:05.501Z",
        "a100-80": "2026-11-03T12:08:05.501Z",
        "a100-40": "2026-11-03T12:08:05.501Z",
        "rtx-pro-6000": "2026-11-03T12:08:05.501Z",
        "l40s": "2026-11-03T12:08:05.501Z",
        "rtx-6000-ada": "2026-11-03T12:08:05.501Z"
      }
    },
    "vast": {
      "name": "Vast.ai",
      "url": "https://vast.ai/pricing",
      "note": "Marketplace: price at which at least two reliable machines (hosts up 90%+ of the time) rent it on demand, per GPU",
      "updated": "2026-11-03T12:08:05.501Z",
      "prices": {
        "b300": 8.979,
        "b200": 10.253,
        "h200": 4.606,
        "h100-nvl": 3.309,
        "h100": 2.149,
        "a100-80": 1.054,
        "a100-40": 0.401,
        "l40s": 0.467,
        "l4": 0.104,
        "rtx-pro-6000": 1.334,
        "rtx-6000-ada": 0.468,
        "rtx-5090": 0.454,
        "rtx-4090": 0.269,
        "rtx-3090": 0.108,
        "rtx-5080": 0.176,
        "a40": 0.482,
        "l40": 0.788,
        "rtx-a6000": 0.43,
        "rtx-a5000": 0.201,
        "rtx-a4000": 0.072,
        "rtx-pro-4000": 0.255
      },
      "seen": {
        "b300": "2026-11-03T12:08:05.501Z",
        "b200": "2026-11-03T12:08:05.501Z",
        "h200": "2026-11-03T12:08:05.501Z",
        "h100-nvl": "2026-11-03T12:08:05.501Z",
        "h100": "2026-11-03T12:08:05.501Z",
        "a100-80": "2026-11-03T12:08:05.501Z",
        "a100-40": "2026-11-03T12:08:05.501Z",
        "l40s": "2026-11-03T12:08:05.501Z",
        "l4": "2026-11-03T12:08:05.501Z",
        "rtx-pro-6000": "2026-11-03T12:08:05.501Z",
        "rtx-6000-ada": "2026-11-03T12:08:05.501Z",
        "rtx-5090": "2026-11-03T12:08:05.501Z",
        "rtx-4090": "2026-11-03T12:08:05.501Z",
        "rtx-3090": "2026-11-03T12:08:05.501Z",
        "rtx-5080": "2026-11-03T12:08:05.501Z",
        "a40": "2026-11-03T12:08:05.501Z",
        "l40": "2026-11-03T12:08:05.501Z",
        "rtx-a6000": "2026-11-03T12:08:05.501Z",
        "rtx-a5000": "2026-11-03T12:08:05.501Z",
        "rtx-a4000": "2026-11-03T12:08:05.501Z",
        "rtx-pro-4000": "2026-11-03T12:08:05.501Z"
      },
      "crossAlerted": {
        "b300": "2026-10-29"
      }
    },
    "azure": {
      "name": "Microsoft Azure",
      "url": "https://azure.microsoft.com/pricing/details/virtual-machines/linux/",
      "note": "Pay-as-you-go Linux VMs, cheapest region, per GPU",
      "updated": "2026-11-03T12:08:05.501Z",
      "prices": {
        "h100": 12.29,
        "h200": 10.6,
        "h100-nvl": 6.98,
        "a100-80": 3.673,
        "a100-40": 3.4,
        "mi300x": 6
      },
      "seen": {
        "h100": "2026-11-03T12:08:05.501Z",
        "h200": "2026-11-03T12:08:05.501Z",
        "h100-nvl": "2026-11-03T12:08:05.501Z",
        "a100-80": "2026-11-03T12:08:05.501Z",
        "a100-40": "2026-11-03T12:08:05.501Z",
        "mi300x": "2026-11-03T12:08:05.501Z"
      }
    },
    "ovh": {
      "name": "OVHcloud",
      "url": "https://www.ovhcloud.com/en/public-cloud/prices/",
      "note": "Public Cloud GPU instances, hourly, excl. VAT, converted from EUR at the ECB rate",
      "updated": "2026-11-03T12:08:05.501Z",
      "prices": {
        "h100-pcie": 3.14,
        "l40s": 1.57,
        "l4": 0.841,
        "a100-80": 3.084,
        "h200": 5.888
      },
      "seen": {
        "h100-pcie": "2026-11-03T12:08:05.501Z",
        "l40s": "2026-11-03T12:08:05.501Z",
        "l4": "2026-11-03T12:08:05.501Z",
        "a100-80": "2026-11-03T12:08:05.501Z",
        "h200": "2026-11-03T12:08:05.501Z"
      }
    },
    "scaleway": {
      "name": "Scaleway",
      "url": "https://www.scaleway.com/en/pricing/gpu/",
      "note": "GPU instances, hourly, excl. VAT, converted from EUR at the ECB rate",
      "updated": "2026-11-03T12:08:05.501Z",
      "prices": {
        "b300": 8.412,
        "h100": 3.551,
        "h100-pcie": 3.215,
        "l40s": 1.649,
        "l4": 0.883
      },
      "seen": {
        "b300": "2026-11-03T12:08:05.501Z",
        "h100": "2026-11-03T12:08:05.501Z",
        "h100-pcie": "2026-11-03T12:08:05.501Z",
        "l40s": "2026-11-03T12:08:05.501Z",
        "l4": "2026-11-03T12:08:05.501Z"
      }
    },
    "oracle": {
      "name": "Oracle Cloud",
      "url": "https://www.oracle.com/cloud/compute/gpu/pricing/",
      "note": "List price per GPU-hour, pay as you go",
      "updated": "2026-11-03T12:08:05.501Z",
      "prices": {
        "l40s": 3.5,
        "mi300x": 6,
        "h200": 10,
        "b200": 14,
        "mi355x": 8.6,
        "b300": 15,
        "rtx-pro-6000": 4.5,
        "a100-80": 4,
        "h100": 10
      },
      "seen": {
        "l40s": "2026-11-03T12:08:05.501Z",
        "mi300x": "2026-11-03T12:08:05.501Z",
        "h200": "2026-11-03T12:08:05.501Z",
        "b200": "2026-11-03T12:08:05.501Z",
        "mi355x": "2026-11-03T12:08:05.501Z",
        "b300": "2026-11-03T12:08:05.501Z",
        "rtx-pro-6000": "2026-11-03T12:08:05.501Z",
        "a100-80": "2026-11-03T12:08:05.501Z",
        "h100": "2026-11-03T12:08:05.501Z"
      }
    },
    "akash": {
      "name": "Akash Network",
      "url": "https://akash.network/pricing/gpus/",
      "note": "Decentralized marketplace: average price weighted by GPUs, as on akash.network, for GPUs available now",
      "updated": "2026-11-03T12:08:05.501Z",
      "prices": {
        "a100-80": 1.67,
        "h100": 2.73,
        "rtx-pro-6000": 1.44,
        "rtx-4080": 0.15,
        "rtx-4090": 0.36
      },
      "seen": {
        "a100-80": "2026-11-03T12:08:05.501Z",
        "h100": "2026-11-03T12:08:05.501Z",
        "rtx-pro-6000": "2026-11-03T12:08:05.501Z",
        "rtx-4080": "2026-11-03T12:08:05.501Z",
        "rtx-4090": "2026-11-03T12:08:05.501Z"
      }
    },
    "aws": {
      "name": "AWS",
      "url": "https://aws.amazon.com/ec2/pricing/on-demand/",
      "note": "On-demand, cheapest region, per GPU. Data: Spare Cores (sparecores.com), CC BY-SA 4.0",
      "license": "CC BY-SA 4.0",
      "updated": "2026-11-03T12:08:05.501Z",
      "prices": {
        "l4": 0.805,
        "rtx-pro-4500": 2.52,
        "l40s": 1.861,
        "rtx-pro-6000": 3.363,
        "h100": 6.88,
        "a100-40": 2.745,
        "h200": 7.912,
        "a100-80": 3.431,
        "b200": 14.242,
        "b300": 17.802
      },
      "seen": {
        "l4": "2026-11-03T12:08:05.501Z",
        "rtx-pro-4500": "2026-11-03T12:08:05.501Z",
        "l40s": "2026-11-03T12:08:05.501Z",
        "rtx-pro-6000": "2026-11-03T12:08:05.501Z",
        "h100": "2026-11-03T12:08:05.501Z",
        "a100-40": "2026-11-03T12:08:05.501Z",
        "h200": "2026-11-03T12:08:05.501Z",
        "a100-80": "2026-11-03T12:08:05.501Z",
        "b200": "2026-11-03T12:08:05.501Z",
        "b300": "2026-11-03T12:08:05.501Z"
      }
    },
    "gcp": {
      "name": "Google Cloud",
      "url": "https://cloud.google.com/compute/gpus-pricing",
      "note": "On-demand, cheapest region, per GPU. Data: Spare Cores (sparecores.com), CC BY-SA 4.0",
      "license": "CC BY-SA 4.0",
      "updated": "2026-11-03T12:08:05.501Z",
      "prices": {
        "l4": 0.705,
        "h100": 10.979,
        "rtx-pro-6000": 4.5,
        "a100-40": 3.484,
        "a100-80": 5.069,
        "h200": 10.436
      },
      "seen": {
        "l4": "2026-11-03T12:08:05.501Z",
        "h100": "2026-11-03T12:08:05.501Z",
        "rtx-pro-6000": "2026-11-03T12:08:05.501Z",
        "a100-40": "2026-11-03T12:08:05.501Z",
        "a100-80": "2026-11-03T12:08:05.501Z",
        "h200": "2026-11-03T12:08:05.501Z"
      }
    },
    "upcloud": {
      "name": "UpCloud",
      "url": "https://upcloud.com/pricing/",
      "note": "On-demand, cheapest region, per GPU. Data: Spare Cores (sparecores.com), CC BY-SA 4.0",
      "license": "CC BY-SA 4.0",
      "updated": "2026-11-03T12:08:05.501Z",
      "prices": {
        "l40s": 1.168,
        "l4": 0.651,
        "rtx-pro-6000": 1.851
      },
      "seen": {
        "l40s": "2026-11-03T12:08:05.501Z",
        "l4": "2026-11-03T11:09:25.898Z",
        "rtx-pro-6000": "2026-11-03T11:09:25.898Z"
      }
    }
  },
  "apisUpdated": "2026-11-03T12:08:05.501Z",
  "apis": {
    "minimaxai/minimax-m3.1-flash": {
      "id": "minimax/minimax-m3.1-flash",
      "name": "MiniMax: MiniMax M3.1 Flash",
      "input": 0.15,
      "output": 0.6
    },
    "deepseek-ai/deepseek-v4.1-flash-1017": {
      "id": "deepseek/deepseek-v4.1-flash-1017",
      "name": "DeepSeek: DeepSeek V4.1 Flash 1017",
      "input": 0.15,
      "output": 0.6
    },
    "reflection/beam-1.0-501b-a23b": {
      "id": "reflection/beam-1.0-501b-a23b",
      "name": "Reflection: Beam 1.0 501B A23B",
      "input": 0.25,
      "output": 1
    },
    "prism-ml/ternary-bonsai-2-9b-gguf": {
      "id": "prism-ml/ternary-bonsai-2-9b",
      "name": "PrismML: Ternary Bonsai 2 9B",
      "input": 0.08,
      "output": 0.13
    },
    "moondream/moondream3-preview": {
      "id": "moondream/moondream3-preview",
      "name": "Moondream: Moondream 3 Preview",
      "input": 0.3,
      "output": 2.5
    },
    "moondream/moondream3.1-9b-a2b": {
      "id": "moondream/moondream3.1-9b-a2b",
      "name": "Moondream: Moondream 3.1",
      "input": 0.3,
      "output": 2.5
    },
    "meta-models/muse-spark-open-816b-a42b": {
      "id": "meta/muse-spark-open",
      "name": "Meta: Muse Spark Open",
      "input": 1.25,
      "output": 4.25
    },
    "nvidia/nvidia-nemotron-3.5-super-vl": {
      "id": "nvidia/nemotron-3.5-super-vl",
      "name": "NVIDIA: Nemotron 3.5 Super VL",
      "input": 0.15,
      "output": 0.5
    },
    "liquidai/lfm2.5-24b-a2b": {
      "id": "liquid/lfm-2.5-24b-a2b",
      "name": "LiquidAI: LFM2.5-24B-A2B",
      "input": 0.05,
      "output": 0.7
    },
    "stepfun-ai/step-5-preview": {
      "id": "stepfun/step-5-preview",
      "name": "StepFun: Step 5 Preview",
      "input": 1,
      "output": 2.7
    },
    "mistralai/mistral-large-4-1t-a52b": {
      "id": "mistralai/mistral-large-4-0",
      "name": "Mistral: Mistral Large 4",
      "input": 0.7,
      "output": 2.1
    },
    "xiaomimimo/mimo-v2.6-flash-rl": {
      "id": "xiaomi/mimo-v2.6-flash",
      "name": "Xiaomi: MiMo-V2.6-Flash",
      "input": 0.14,
      "output": 0.28
    },
    "xiaomimimo/mimo-v2.6-pro-rl": {
      "id": "xiaomi/mimo-v2.6-pro",
      "name": "Xiaomi: MiMo-V2.6-Pro",
      "input": 0.435,
      "output": 0.87
    },
    "prism-ml/ternary-bonsai-2-27b-gguf": {
      "id": "prism-ml/ternary-bonsai-2-27b",
      "name": "PrismML: Ternary Bonsai 2 27B",
      "input": 0.075,
      "output": 0.5
    },
    "inference-net/schematron-v2-granite-4.0-h-micro": {
      "id": "inference-net/schematron-v2-turbo",
      "name": "Inference.net: Schematron V2 Turbo",
      "input": 0.03,
      "output": 0.15
    },
    "inference-net/schematron-v2-llama-3.2-3b": {
      "id": "inference-net/schematron-v2-small",
      "name": "Inference.net: Schematron V2 Small",
      "input": 0.05,
      "output": 0.23
    },
    "inclusionai/ling-3.0-flash-vl": {
      "id": "inclusionai/ling-3.0-flash-vl",
      "name": "inclusionAI: Ling 3.0 Flash VL",
      "input": 0.06,
      "output": 0.18
    },
    "deepseek-ai/deepseek-v4.1-flash": {
      "id": "deepseek/deepseek-v4.1-flash",
      "name": "DeepSeek: DeepSeek V4.1 Flash",
      "input": 0.045,
      "output": 0.5
    },
    "nex-agi/nex-n2.5-mini": {
      "id": "nex-agi/nex-n2.5-mini",
      "name": "Nex AGI: Nex-N2.5-Mini",
      "input": 0.025,
      "output": 0.1
    },
    "nex-agi/nex-n2.5-pro": {
      "id": "nex-agi/nex-n2.5-pro",
      "name": "Nex AGI: Nex-N2.5-Pro",
      "input": 0.075,
      "output": 0.25
    },
    "ibm-granite/granite-4.2-8b": {
      "id": "ibm-granite/granite-4.2-8b",
      "name": "IBM: Granite 4.2 8B",
      "input": 0.06,
      "output": 0.15
    },
    "tencent/hy4-preview": {
      "id": "tencent/hy4-preview",
      "name": "Tencent: Hy4 preview",
      "input": 0.834,
      "output": 2.501
    },
    "qwen/qwen3.8-flash-next": {
      "id": "qwen/qwen3.8-flash",
      "name": "Qwen: Qwen3.8 Flash",
      "input": 0.15,
      "output": 0.47
    },
    "zai-org/glm-5.3-flash": {
      "id": "z-ai/glm-5.3-flash",
      "name": "Z.ai: GLM 5.3 Flash",
      "input": 0.031,
      "output": 0.085
    },
    "deepseek-ai/deepseek-v4-flash-vision-exp": {
      "id": "deepseek/deepseek-v4-flash-vision-exp",
      "name": "DeepSeek: DeepSeek V4 Flash Vision Exp",
      "input": 0.216,
      "output": 0.647
    },
    "tencent/hy-mt2-1.8b": {
      "id": "tencent/hy-mt2-1.8b",
      "name": "Tencent: Hy-MT2-1.8B",
      "input": 0.044,
      "output": 0.177
    },
    "tencent/hy-mt2-30b-a3b": {
      "id": "tencent/hy-mt2-30b-a3b",
      "name": "Tencent: Hy-MT2-30B-A3B",
      "input": 0.074,
      "output": 0.295
    },
    "tencent/hy-mt2-7b": {
      "id": "tencent/hy-mt2-7b",
      "name": "Tencent: Hy-MT2-7B",
      "input": 0.074,
      "output": 0.295
    },
    "zai-org/glm-5.3": {
      "id": "z-ai/glm-5.3",
      "name": "Z.ai: GLM 5.3",
      "input": 0.08,
      "output": 3.6
    },
    "qwen/qwen3.8-27b": {
      "id": "qwen/qwen3.8-27b",
      "name": "Qwen: Qwen3.8 27B",
      "input": 0.15,
      "output": 1.875
    },
    "qwen/qwen3.8-2.4t-a95b": {
      "id": "qwen/qwen3.8-2.4t-a95b",
      "name": "Qwen: Qwen3.8 2.4T A95B",
      "input": 2,
      "output": 6
    },
    "deepseek-ai/deepseek-v4-pro-0813": {
      "id": "deepseek/deepseek-v4-pro-0813",
      "name": "DeepSeek: DeepSeek V4 Pro 0813",
      "input": 0.115,
      "output": 4
    },
    "liquidai/lfm2.5-2.6b": {
      "id": "liquid/lfm-2.5-2.6b",
      "name": "LiquidAI: LFM2.5-2.6B",
      "input": 0.35,
      "output": 0.5
    },
    "nvidia/nvidia-nemotron-3.5-lightning-30b-a3b-bf16": {
      "id": "nvidia/nemotron-3.5-lightning",
      "name": "NVIDIA: Nemotron 3.5 Lightning",
      "input": 0.07,
      "output": 0.2
    },
    "meta-models/muse-glimmer-30b": {
      "id": "meta/muse-glimmer-30b",
      "name": "Meta: Muse Glimmer 30B",
      "input": 0.3,
      "output": 1.2
    },
    "deepseek-ai/deepseek-v4-flash-0731": {
      "id": "deepseek/deepseek-v4-flash-0731",
      "name": "DeepSeek: DeepSeek V4 Flash 0731",
      "input": 0.059,
      "output": 0.3
    },
    "thinkingmachines/inkling-small": {
      "id": "thinkingmachines/inkling-small",
      "name": "Thinking Machines: Inkling Small",
      "input": 0.45,
      "output": 1.2
    },
    "inclusionai/ling-3.0-flash": {
      "id": "inclusionai/ling-3.0-flash",
      "name": "inclusionAI: Ling 3.0 Flash",
      "input": 0.021,
      "output": 0.063
    },
    "meituan-longcat/longcat-2.0": {
      "id": "meituan/longcat-2.0",
      "name": "Meituan: LongCat 2.0",
      "input": 0.3,
      "output": 1.2
    },
    "thinkingmachines/inkling": {
      "id": "thinkingmachines/inkling",
      "name": "Thinking Machines: Inkling",
      "input": 1,
      "output": 4.05
    },
    "moonshotai/kimi-k3": {
      "id": "moonshotai/kimi-k3",
      "name": "MoonshotAI: Kimi K3",
      "input": 0.192,
      "output": 15
    },
    "tencent/hy3": {
      "id": "tencent/hy3",
      "name": "Tencent: Hy3",
      "input": 0.132,
      "output": 0.528
    },
    "zai-org/glm-5.2": {
      "id": "z-ai/glm-5.2",
      "name": "Z.ai: GLM 5.2",
      "input": 0.006,
      "output": 6.8
    },
    "moonshotai/kimi-k2.7-code": {
      "id": "moonshotai/kimi-k2.7-code",
      "name": "MoonshotAI: Kimi K2.7 Code",
      "input": 0.6,
      "output": 3.5
    },
    "nvidia/nemotron-3.5-content-safety": {
      "id": "nvidia/nemotron-3.5-content-safety",
      "name": "NVIDIA: Nemotron 3.5 Content Safety",
      "input": 0.2,
      "output": 0.2
    },
    "nvidia/nvidia-nemotron-3-ultra-550b-a55b-bf16": {
      "id": "nvidia/nemotron-3-ultra-550b-a55b",
      "name": "NVIDIA: Nemotron 3 Ultra",
      "input": 0.6,
      "output": 2.4
    },
    "minimaxai/minimax-m3": {
      "id": "minimax/minimax-m3",
      "name": "MiniMax: MiniMax M3",
      "input": 0.3,
      "output": 1.2
    },
    "stepfun-ai/step-3.7-flash": {
      "id": "stepfun/step-3.7-flash",
      "name": "StepFun: Step 3.7 Flash",
      "input": 0.2,
      "output": 1.15
    },
    "qwen/qwen3.6-35b-a3b": {
      "id": "qwen/qwen3.6-35b-a3b",
      "name": "Qwen: Qwen3.6 35B A3B",
      "input": 0.1,
      "output": 0.9
    },
    "qwen/qwen3.6-27b": {
      "id": "qwen/qwen3.6-27b",
      "name": "Qwen: Qwen3.6 27B",
      "input": 0.45,
      "output": 2.7
    },
    "deepseek-ai/deepseek-v4-pro": {
      "id": "deepseek/deepseek-v4-pro",
      "name": "DeepSeek: DeepSeek V4 Pro 0423",
      "input": 1.6,
      "output": 3.2
    },
    "deepseek-ai/deepseek-v4-flash": {
      "id": "deepseek/deepseek-v4-flash",
      "name": "DeepSeek: DeepSeek V4 Flash 0423",
      "input": 0.091,
      "output": 0.182
    },
    "tencent/hy3-preview": {
      "id": "tencent/hy3-preview",
      "name": "Tencent: Hy3 preview",
      "input": 0.18,
      "output": 0.6
    },
    "xiaomimimo/mimo-v2.5-pro": {
      "id": "xiaomi/mimo-v2.5-pro",
      "name": "Xiaomi: MiMo-V2.5-Pro",
      "input": 0.48,
      "output": 1.8
    },
    "xiaomimimo/mimo-v2.5": {
      "id": "xiaomi/mimo-v2.5",
      "name": "Xiaomi: MiMo-V2.5",
      "input": 0.4,
      "output": 2
    },
    "moonshotai/kimi-k2.6": {
      "id": "moonshotai/kimi-k2.6",
      "name": "MoonshotAI: Kimi K2.6",
      "input": 0.65,
      "output": 3.41
    },
    "zai-org/glm-5.1": {
      "id": "z-ai/glm-5.1",
      "name": "Z.ai: GLM 5.1",
      "input": 1.4,
      "output": 4.4
    },
    "google/gemma-4-26b-a4b-it": {
      "id": "google/gemma-4-26b-a4b-it",
      "name": "Google: Gemma 4 26B A4B ",
      "input": 0.051,
      "output": 0.152
    },
    "google/gemma-4-31b-it": {
      "id": "google/gemma-4-31b-it",
      "name": "Google: Gemma 4 31B",
      "input": 0.2,
      "output": 0.4
    },
    "rekaai/reka-edge-2603": {
      "id": "rekaai/reka-edge",
      "name": "Reka Edge",
      "input": 0.1,
      "output": 0.1
    },
    "minimaxai/minimax-m2.7": {
      "id": "minimax/minimax-m2.7",
      "name": "MiniMax: MiniMax M2.7",
      "input": 0.3,
      "output": 1.2
    },
    "mistralai/mistral-small-4-119b-2603": {
      "id": "mistralai/mistral-small-2603",
      "name": "Mistral: Mistral Small 4",
      "input": 0.15,
      "output": 0.6
    },
    "nvidia/nvidia-nemotron-3-super-120b-a12b-fp8": {
      "id": "nvidia/nemotron-3-super-120b-a12b",
      "name": "NVIDIA: Nemotron 3 Super",
      "input": 0.3,
      "output": 2.4
    },
    "qwen/qwen3.5-9b": {
      "id": "qwen/qwen3.5-9b",
      "name": "Qwen: Qwen3.5-9B",
      "input": 0.17,
      "output": 0.25
    },
    "qwen/qwen3.5-35b-a3b": {
      "id": "qwen/qwen3.5-35b-a3b",
      "name": "Qwen: Qwen3.5-35B-A3B",
      "input": 0.14,
      "output": 1
    },
    "qwen/qwen3.5-27b": {
      "id": "qwen/qwen3.5-27b",
      "name": "Qwen: Qwen3.5-27B",
      "input": 0.26,
      "output": 2.6
    },
    "qwen/qwen3.5-122b-a10b": {
      "id": "qwen/qwen3.5-122b-a10b",
      "name": "Qwen: Qwen3.5-122B-A10B",
      "input": 0.26,
      "output": 2.08
    },
    "qwen/qwen3.5-397b-a17b": {
      "id": "qwen/qwen3.5-397b-a17b",
      "name": "Qwen: Qwen3.5 397B A17B",
      "input": 0.5,
      "output": 3.6
    },
    "minimaxai/minimax-m2.5": {
      "id": "minimax/minimax-m2.5",
      "name": "MiniMax: MiniMax M2.5",
      "input": 0.27,
      "output": 0.95
    },
    "zai-org/glm-5": {
      "id": "z-ai/glm-5",
      "name": "Z.ai: GLM 5",
      "input": 1,
      "output": 3.2
    },
    "qwen/qwen3-coder-next": {
      "id": "qwen/qwen3-coder-next",
      "name": "Qwen: Qwen3 Coder Next",
      "input": 0.12,
      "output": 0.8
    },
    "stepfun-ai/step-3.5-flash": {
      "id": "stepfun/step-3.5-flash",
      "name": "StepFun: Step 3.5 Flash",
      "input": 0.1,
      "output": 0.3
    },
    "moonshotai/kimi-k2.5": {
      "id": "moonshotai/kimi-k2.5",
      "name": "MoonshotAI: Kimi K2.5",
      "input": 0.5,
      "output": 2.5
    },
    "zai-org/glm-4.7-flash": {
      "id": "z-ai/glm-4.7-flash",
      "name": "Z.ai: GLM 4.7 Flash",
      "input": 0.061,
      "output": 0.4
    },
    "minimaxai/minimax-m2.1": {
      "id": "minimax/minimax-m2.1",
      "name": "MiniMax: MiniMax M2.1",
      "input": 0.3,
      "output": 1.2
    },
    "zai-org/glm-4.7": {
      "id": "z-ai/glm-4.7",
      "name": "Z.ai: GLM 4.7",
      "input": 0.6,
      "output": 2.2
    },
    "nvidia/nvidia-nemotron-3-nano-30b-a3b-bf16": {
      "id": "nvidia/nemotron-3-nano-30b-a3b",
      "name": "NVIDIA: Nemotron 3 Nano 30B A3B",
      "input": 0.06,
      "output": 0.24
    },
    "mistralai/devstral-2-123b-instruct-2512": {
      "id": "mistralai/devstral-2512",
      "name": "Mistral: Devstral 2 2512",
      "input": 0.4,
      "output": 2
    },
    "zai-org/glm-4.6v": {
      "id": "z-ai/glm-4.6v",
      "name": "Z.ai: GLM 4.6V",
      "input": 0.3,
      "output": 0.9
    },
    "mistralai/ministral-3-14b-instruct-2512": {
      "id": "mistralai/ministral-14b-2512",
      "name": "Mistral: Ministral 3 14B 2512",
      "input": 0.2,
      "output": 0.2
    },
    "mistralai/ministral-3-8b-instruct-2512": {
      "id": "mistralai/ministral-8b-2512",
      "name": "Mistral: Ministral 3 8B 2512",
      "input": 0.15,
      "output": 0.15
    },
    "mistralai/ministral-3-3b-instruct-2512": {
      "id": "mistralai/ministral-3b-2512",
      "name": "Mistral: Ministral 3 3B 2512",
      "input": 0.1,
      "output": 0.1
    },
    "deepseek-ai/deepseek-v3.2": {
      "id": "deepseek/deepseek-v3.2",
      "name": "DeepSeek: DeepSeek V3.2",
      "input": 0.26,
      "output": 0.38
    },
    "moonshotai/kimi-k2-thinking": {
      "id": "moonshotai/kimi-k2-thinking",
      "name": "MoonshotAI: Kimi K2 Thinking",
      "input": 0.6,
      "output": 2.5
    },
    "mistralai/voxtral-small-24b-2507": {
      "id": "mistralai/voxtral-small-24b-2507",
      "name": "Mistral: Voxtral Small 24B 2507",
      "input": 0.1,
      "output": 0.3
    },
    "openai/gpt-oss-safeguard-20b": {
      "id": "openai/gpt-oss-safeguard-20b",
      "name": "OpenAI: gpt-oss-safeguard-20b",
      "input": 0.075,
      "output": 0.3
    },
    "minimaxai/minimax-m2": {
      "id": "minimax/minimax-m2",
      "name": "MiniMax: MiniMax M2",
      "input": 0.255,
      "output": 1.02
    },
    "qwen/qwen3-vl-8b-instruct": {
      "id": "qwen/qwen3-vl-8b-instruct",
      "name": "Qwen: Qwen3 VL 8B Instruct",
      "input": 0.25,
      "output": 0.75
    },
    "qwen/qwen3-vl-30b-a3b-thinking": {
      "id": "qwen/qwen3-vl-30b-a3b-thinking",
      "name": "Qwen: Qwen3 VL 30B A3B Thinking",
      "input": 0.29,
      "output": 1
    },
    "qwen/qwen3-vl-30b-a3b-instruct": {
      "id": "qwen/qwen3-vl-30b-a3b-instruct",
      "name": "Qwen: Qwen3 VL 30B A3B Instruct",
      "input": 0.15,
      "output": 0.6
    },
    "zai-org/glm-4.6": {
      "id": "z-ai/glm-4.6",
      "name": "Z.ai: GLM 4.6",
      "input": 0.5,
      "output": 2
    },
    "deepseek-ai/deepseek-v3.2-exp": {
      "id": "deepseek/deepseek-v3.2-exp",
      "name": "DeepSeek: DeepSeek V3.2 Exp",
      "input": 0.27,
      "output": 0.41
    },
    "thedrummer/cydonia-24b-v4.1": {
      "id": "thedrummer/cydonia-24b-v4.1",
      "name": "TheDrummer: Cydonia 24B V4.1",
      "input": 0.3,
      "output": 0.5
    },
    "qwen/qwen3-vl-235b-a22b-instruct": {
      "id": "qwen/qwen3-vl-235b-a22b-instruct",
      "name": "Qwen: Qwen3 VL 235B A22B Instruct",
      "input": 0.21,
      "output": 1.9
    },
    "deepseek-ai/deepseek-v3.1-terminus": {
      "id": "deepseek/deepseek-v3.1-terminus",
      "name": "DeepSeek: DeepSeek V3.1 Terminus",
      "input": 0.27,
      "output": 1
    },
    "qwen/qwen3-next-80b-a3b-instruct": {
      "id": "qwen/qwen3-next-80b-a3b-instruct",
      "name": "Qwen: Qwen3 Next 80B A3B Instruct",
      "input": 0.1,
      "output": 1.1
    },
    "moonshotai/kimi-k2-instruct-0905": {
      "id": "moonshotai/kimi-k2-0905",
      "name": "MoonshotAI: Kimi K2 0905",
      "input": 0.6,
      "output": 2.5
    },
    "nousresearch/hermes-4-405b": {
      "id": "nousresearch/hermes-4-405b",
      "name": "Nous: Hermes 4 405B",
      "input": 1,
      "output": 3
    },
    "deepseek-ai/deepseek-v3.1": {
      "id": "deepseek/deepseek-chat-v3.1",
      "name": "DeepSeek: DeepSeek V3.1",
      "input": 0.25,
      "output": 0.95
    },
    "zai-org/glm-4.5v": {
      "id": "z-ai/glm-4.5v",
      "name": "Z.ai: GLM 4.5V",
      "input": 0.6,
      "output": 1.8
    },
    "openai/gpt-oss-120b": {
      "id": "openai/gpt-oss-120b",
      "name": "OpenAI: gpt-oss-120b",
      "input": 0.15,
      "output": 0.6
    },
    "openai/gpt-oss-20b": {
      "id": "openai/gpt-oss-20b",
      "name": "OpenAI: gpt-oss-20b",
      "input": 0.03,
      "output": 0.13
    },
    "qwen/qwen3-coder-30b-a3b-instruct": {
      "id": "qwen/qwen3-coder-30b-a3b-instruct",
      "name": "Qwen: Qwen3 Coder 30B A3B Instruct",
      "input": 0.15,
      "output": 0.6
    },
    "qwen/qwen3-30b-a3b-instruct-2507": {
      "id": "qwen/qwen3-30b-a3b-instruct-2507",
      "name": "Qwen: Qwen3 30B A3B Instruct 2507",
      "input": 0.1,
      "output": 0.3
    },
    "zai-org/glm-4.5": {
      "id": "z-ai/glm-4.5",
      "name": "Z.ai: GLM 4.5",
      "input": 0.6,
      "output": 2.2
    },
    "zai-org/glm-4.5-air": {
      "id": "z-ai/glm-4.5-air",
      "name": "Z.ai: GLM 4.5 Air",
      "input": 0.13,
      "output": 0.85
    },
    "qwen/qwen3-235b-a22b-thinking-2507": {
      "id": "qwen/qwen3-235b-a22b-thinking-2507",
      "name": "Qwen: Qwen3 235B A22B Thinking 2507",
      "input": 0.45,
      "output": 3.5
    },
    "qwen/qwen3-coder-480b-a35b-instruct": {
      "id": "qwen/qwen3-coder",
      "name": "Qwen: Qwen3 Coder 480B A35B",
      "input": 0.3,
      "output": 1
    },
    "bytedance-seed/ui-tars-1.5-7b": {
      "id": "bytedance/ui-tars-1.5-7b",
      "name": "ByteDance: UI-TARS 7B ",
      "input": 0.1,
      "output": 0.2
    },
    "qwen/qwen3-235b-a22b-instruct-2507": {
      "id": "qwen/qwen3-235b-a22b-2507",
      "name": "Qwen: Qwen3 235B A22B Instruct 2507",
      "input": 0.09,
      "output": 0.55
    },
    "moonshotai/kimi-k2-instruct": {
      "id": "moonshotai/kimi-k2",
      "name": "MoonshotAI: Kimi K2 0711",
      "input": 0.57,
      "output": 2.3
    },
    "cognitivecomputations/dolphin-mistral-24b-venice-edition": {
      "id": "cognitivecomputations/dolphin-mistral-24b-venice-edition",
      "name": "Venice: Uncensored",
      "input": 0.2,
      "output": 0.9
    },
    "tencent/hunyuan-a13b-instruct": {
      "id": "tencent/hunyuan-a13b-instruct",
      "name": "Tencent: Hunyuan A13B Instruct",
      "input": 0.14,
      "output": 0.57
    },
    "mistralai/mistral-small-3.2-24b-instruct-2506": {
      "id": "mistralai/mistral-small-3.2-24b-instruct",
      "name": "Mistral: Mistral Small 3.2 24B",
      "input": 0.075,
      "output": 0.2
    },
    "deepseek-ai/deepseek-r1-0528": {
      "id": "deepseek/deepseek-r1-0528",
      "name": "DeepSeek: R1 0528",
      "input": 0.5,
      "output": 2.15
    },
    "meta-llama/llama-guard-4-12b": {
      "id": "meta-llama/llama-guard-4-12b",
      "name": "Meta: Llama Guard 4 12B",
      "input": 0.18,
      "output": 0.18
    },
    "qwen/qwen3-30b-a3b": {
      "id": "qwen/qwen3-30b-a3b",
      "name": "Qwen: Qwen3 30B A3B",
      "input": 0.12,
      "output": 0.5
    },
    "qwen/qwen3-14b": {
      "id": "qwen/qwen3-14b",
      "name": "Qwen: Qwen3 14B",
      "input": 0.12,
      "output": 0.24
    },
    "qwen/qwen3-32b": {
      "id": "qwen/qwen3-32b",
      "name": "Qwen: Qwen3 32B",
      "input": 0.08,
      "output": 0.28
    },
    "meta-llama/llama-4-maverick-17b-128e-instruct": {
      "id": "meta-llama/llama-4-maverick",
      "name": "Meta: Llama 4 Maverick",
      "input": 0.188,
      "output": 0.653
    },
    "meta-llama/llama-4-scout-17b-16e-instruct": {
      "id": "meta-llama/llama-4-scout",
      "name": "Meta: Llama 4 Scout",
      "input": 0.1,
      "output": 0.3
    },
    "deepseek-ai/deepseek-v3-0324": {
      "id": "deepseek/deepseek-chat-v3-0324",
      "name": "DeepSeek: DeepSeek V3 0324",
      "input": 0.29,
      "output": 1.14
    },
    "mistralai/mistral-small-3.1-24b-instruct-2503": {
      "id": "mistralai/mistral-small-3.1-24b-instruct",
      "name": "Mistral: Mistral Small 3.1 24B",
      "input": 0.351,
      "output": 0.555
    },
    "google/gemma-3-4b-it": {
      "id": "google/gemma-3-4b-it",
      "name": "Google: Gemma 3 4B",
      "input": 0.05,
      "output": 0.1
    },
    "google/gemma-3-12b-it": {
      "id": "google/gemma-3-12b-it",
      "name": "Google: Gemma 3 12B",
      "input": 0.05,
      "output": 0.15
    },
    "cohereforai/c4ai-command-a-03-2025": {
      "id": "cohere/command-a",
      "name": "Cohere: Command A",
      "input": 2.5,
      "output": 10
    },
    "rekaai/reka-flash-3": {
      "id": "rekaai/reka-flash-3",
      "name": "Reka Flash 3",
      "input": 0.1,
      "output": 0.2
    },
    "google/gemma-3-27b-it": {
      "id": "google/gemma-3-27b-it",
      "name": "Google: Gemma 3 27B",
      "input": 0.08,
      "output": 0.35
    },
    "thedrummer/skyfall-36b-v2": {
      "id": "thedrummer/skyfall-36b-v2",
      "name": "TheDrummer: Skyfall 36B V2",
      "input": 0.55,
      "output": 0.8
    },
    "qwen/qwen2.5-vl-72b-instruct": {
      "id": "qwen/qwen2.5-vl-72b-instruct",
      "name": "Qwen: Qwen2.5 VL 72B Instruct",
      "input": 0.8,
      "output": 1
    },
    "mistralai/mistral-small-24b-instruct-2501": {
      "id": "mistralai/mistral-small-24b-instruct-2501",
      "name": "Mistral: Mistral Small 3",
      "input": 0.05,
      "output": 0.08
    },
    "minimaxai/minimax-text-01": {
      "id": "minimax/minimax-01",
      "name": "MiniMax: MiniMax-01",
      "input": 0.2,
      "output": 1.1
    },
    "microsoft/phi-4": {
      "id": "microsoft/phi-4",
      "name": "Microsoft: Phi 4",
      "input": 0.07,
      "output": 0.14
    },
    "deepseek-ai/deepseek-v3": {
      "id": "deepseek/deepseek-chat",
      "name": "DeepSeek: DeepSeek V3",
      "input": 0.257,
      "output": 1.029
    },
    "meta-llama/llama-3.3-70b-instruct": {
      "id": "meta-llama/llama-3.3-70b-instruct",
      "name": "Meta: Llama 3.3 70B Instruct",
      "input": 0.2,
      "output": 0.52
    },
    "qwen/qwen2.5-coder-32b-instruct": {
      "id": "qwen/qwen-2.5-coder-32b-instruct",
      "name": "Qwen2.5 Coder 32B Instruct",
      "input": 0.66,
      "output": 1
    },
    "thedrummer/unslopnemo-12b-v4.1": {
      "id": "thedrummer/unslopnemo-12b",
      "name": "TheDrummer: UnslopNemo 12B",
      "input": 0.4,
      "output": 0.4
    },
    "anthracite-org/magnum-v4-72b": {
      "id": "anthracite-org/magnum-v4-72b",
      "name": "Magnum v4 72B",
      "input": 2.5,
      "output": 5
    },
    "qwen/qwen2.5-7b-instruct": {
      "id": "qwen/qwen-2.5-7b-instruct",
      "name": "Qwen: Qwen2.5 7B Instruct",
      "input": 0.1,
      "output": 0.2
    },
    "meta-llama/llama-3.2-1b-instruct": {
      "id": "meta-llama/llama-3.2-1b-instruct",
      "name": "Meta: Llama 3.2 1B Instruct",
      "input": 0.027,
      "output": 0.201
    },
    "meta-llama/llama-3.2-3b-instruct": {
      "id": "meta-llama/llama-3.2-3b-instruct",
      "name": "Meta: Llama 3.2 3B Instruct",
      "input": 0.051,
      "output": 0.335
    },
    "qwen/qwen2.5-72b-instruct": {
      "id": "qwen/qwen-2.5-72b-instruct",
      "name": "Qwen2.5 72B Instruct",
      "input": 0.36,
      "output": 0.4
    },
    "sao10k/l3.1-70b-euryale-v2.2": {
      "id": "sao10k/l3.1-euryale-70b",
      "name": "Sao10K: Llama 3.1 Euryale 70B v2.2",
      "input": 0.85,
      "output": 0.85
    },
    "sao10k/l3-8b-lunaris-v1": {
      "id": "sao10k/l3-lunaris-8b",
      "name": "Sao10K: Llama 3 8B Lunaris",
      "input": 0.04,
      "output": 0.05
    },
    "meta-llama/meta-llama-3.1-70b-instruct": {
      "id": "meta-llama/llama-3.1-70b-instruct",
      "name": "Meta: Llama 3.1 70B Instruct",
      "input": 0.72,
      "output": 0.72
    },
    "meta-llama/meta-llama-3.1-8b-instruct": {
      "id": "meta-llama/llama-3.1-8b-instruct",
      "name": "Meta: Llama 3.1 8B Instruct",
      "input": 0.05,
      "output": 0.08
    },
    "mistralai/mistral-nemo-instruct-2407": {
      "id": "mistralai/mistral-nemo",
      "name": "Mistral: Mistral Nemo",
      "input": 0.029,
      "output": 0.03
    },
    "google/gemma-2-27b-it": {
      "id": "google/gemma-2-27b-it",
      "name": "Google: Gemma 2 27B",
      "input": 0.65,
      "output": 0.65
    },
    "mistralai/mixtral-8x22b-instruct-v0.1": {
      "id": "mistralai/mixtral-8x22b-instruct",
      "name": "Mistral: Mixtral 8x22B Instruct",
      "input": 2,
      "output": 6
    },
    "undi95/remm-slerp-l2-13b": {
      "id": "undi95/remm-slerp-l2-13b",
      "name": "ReMM SLERP 13B",
      "input": 0.35,
      "output": 0.65
    },
    "gryphe/mythomax-l2-13b": {
      "id": "gryphe/mythomax-l2-13b",
      "name": "MythoMax 13B",
      "input": 0.08,
      "output": 0.11
    }
  },
  "electricity": {
    "period": "2026-S1",
    "checked": "2026-11-02T17:07:25.836Z",
    "eurUsd": 1.1216,
    "countries": {
      "EU": {
        "name": "EU average",
        "eur": 0.2832
      },
      "EA": {
        "name": "Euro area",
        "eur": 0.2851
      },
      "BE": {
        "name": "Belgium",
        "eur": 0.3575
      },
      "BG": {
        "name": "Bulgaria",
        "eur": 0.1341
      },
      "CZ": {
        "name": "Czechia",
        "eur": 0.2884
      },
      "DK": {
        "name": "Denmark",
        "eur": 0.2375
      },
      "DE": {
        "name": "Germany",
        "eur": 0.3618
      },
      "EE": {
        "name": "Estonia",
        "eur": 0.2118
      },
      "IE": {
        "name": "Ireland",
        "eur": 0.3871
      },
      "GR": {
        "name": "Greece",
        "eur": 0.2401
      },
      "ES": {
        "name": "Spain",
        "eur": 0.2509
      },
      "FR": {
        "name": "France",
        "eur": 0.2485
      },
      "HR": {
        "name": "Croatia",
        "eur": 0.1816
      },
      "IT": {
        "name": "Italy",
        "eur": 0.3142
      },
      "CY": {
        "name": "Cyprus",
        "eur": 0.2688
      },
      "LV": {
        "name": "Latvia",
        "eur": 0.2415
      },
      "LT": {
        "name": "Lithuania",
        "eur": 0.2162
      },
      "LU": {
        "name": "Luxembourg",
        "eur": 0.2023
      },
      "HU": {
        "name": "Hungary",
        "eur": 0.1139
      },
      "MT": {
        "name": "Malta",
        "eur": 0.1268
      },
      "NL": {
        "name": "Netherlands",
        "eur": 0.244
      },
      "AT": {
        "name": "Austria",
        "eur": 0.326
      },
      "PL": {
        "name": "Poland",
        "eur": 0.2999
      },
      "PT": {
        "name": "Portugal",
        "eur": 0.2367
      },
      "RO": {
        "name": "Romania",
        "eur": 0.2836
      },
      "SI": {
        "name": "Slovenia",
        "eur": 0.2118
      },
      "SK": {
        "name": "Slovakia",
        "eur": 0.1985
      },
      "FI": {
        "name": "Finland",
        "eur": 0.2694
      },
      "SE": {
        "name": "Sweden",
        "eur": 0.3062
      },
      "IS": {
        "name": "Iceland",
        "eur": 0.2076
      },
      "LI": {
        "name": "Liechtenstein",
        "eur": 0.2988
      },
      "NO": {
        "name": "Norway",
        "eur": 0.1993
      },
      "BA": {
        "name": "Bosnia and Herzegovina",
        "eur": 0.0995
      },
      "ME": {
        "name": "Montenegro",
        "eur": 0.1039
      },
      "MD": {
        "name": "Moldova",
        "eur": 0.1872
      },
      "MK": {
        "name": "North Macedonia",
        "eur": 0.1168
      },
      "GE": {
        "name": "Georgia",
        "eur": 0.0731
      },
      "AL": {
        "name": "Albania",
        "eur": 0.119
      },
      "RS": {
        "name": "Serbia",
        "eur": 0.1197
      },
      "TR": {
        "name": "Türkiye",
        "eur": 0.0657
      },
      "XK": {
        "name": "Kosovo",
        "eur": 0.0869
      }
    }
  }
}
